module.exports = __webpack_public_path__ + "static/media/home-page-assortment.5c9b43fd.png";